import { Component, ElementRef, Input, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { GbrLocationInput } from '@coin/shared/gbr/util';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import {
  V2CardComponent,
  V2CheckboxComponent,
  V2TextInputComponent,
  V2NumberInputComponent
} from '@coin/shared/core/ui-storybook';

@Component({
  selector: 'coin-siemens-energy-location-input',
  templateUrl: './location-input.component.html',
  styleUrls: ['./location-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    V2CardComponent,
    MatIcon,
    V2CheckboxComponent,
    FormsModule,
    V2TextInputComponent,
    V2NumberInputComponent,
    TranslatePipe
  ]
})
export class LocationInputComponent {
  private readonly translateService = inject(TranslateService);

  @Input() data: GbrLocationInput;

  @ViewChild('wrapper') wrapper: ElementRef;
  @ViewChild('editPart') editPart: ElementRef;

  get hasFocus(): boolean {
    return !!this.editPart?.nativeElement?.matches(':focus-within');
  }

  get selectionLabel(): string {
    if (this.data?.sameAsEmployee) {
      return this.translateService.instant('general.yes');
    }

    if (this.hasFocus || !this.data?.number || !this.data?.postalCode || !this.data?.street) {
      return this.translateService.instant('gbr.location.selection-label');
    }

    return `${this.data?.street} ${this.data?.number}, ${this.data?.postalCode}`;
  }

  public onSameToggle(value: boolean): void {
    this.data.sameAsEmployee = value;
  }

  public toggleEdit(): void {
    const newEdit = !this.hasFocus;
    setTimeout(() => (newEdit ? this.editPart.nativeElement.focus() : this.wrapper.nativeElement.focus()), 0);
  }
}
